/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react';
import {ScorecardTable} from '../styles';
import {Utils} from '../../../../utils/api';
import {GoChevronDown, GoChevronUp} from 'react-icons/go';
import {SelectPlayerColumn} from '../../../../components';
import {ColumnContainerSummary, ArrowHolderSummary} from '../../../../components/Table/styles';
import {default as TableContainer} from '../tableContainer';

export default ({dataTableContent}: {dataTableContent: Array<any>}) => {
  const [table, useTable] = useState<Array<any>>(dataTableContent);
  const [sort, useSort] = useState<string>('');
  const [reverse, useReverse] = useState<boolean>(false);
  const sortOptions = [!reverse, changeTable, table];
  const UTILS = new Utils();
  useEffect(() => {
    const newExams = dataTableContent?.filter(item => {
      if (item?.personalRecords?.date) {
        return item;
      } else {
        return false;
      }
    });
    useTable(newExams);
  }, [dataTableContent]);
  function changeTable(e) {
    useTable([...e]);
  }

  function toggleSortString(sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortStrings(params, sortOptions);
  }

  const SortingTableHead = ({
    title,
    attr,
    location,
    sortFunction,
  }: {
    title?: string;
    attr?: any;
    location?: any;
    sortFunction: Function;
  }) => {
    return (
      <th onClick={() => sortFunction(attr, location)}>
        <ColumnContainerSummary>
          <span>{title}</span>
          <ArrowHolderSummary>
            {sort === attr && reverse && <GoChevronDown size={14} />}
            {sort === attr && !reverse && <GoChevronUp size={14} />}
          </ArrowHolderSummary>
        </ColumnContainerSummary>
      </th>
    );
  };

  return (
    <TableContainer
      title="Personal Records - PR"
      numberOfPlayers={table.length}
      subTitle="Any PR after the first rsult (velocity, strength)">
      <ScorecardTable>
        <thead>
          <tr>
            <SortingTableHead title="Players" attr="firstName" location={['player', 'firstName']} sortFunction={toggleSortString} />
            <SortingTableHead title="Date" attr="date" location={['personalRecords', 'date']} sortFunction={toggleSortString} />
            <SortingTableHead
              title="Category"
              attr="category"
              location={['personalRecords', 'category']}
              sortFunction={toggleSortString}
            />
            <SortingTableHead
              title="Situation / Ball"
              attr="situation"
              location={['personalRecords', 'situation']}
              sortFunction={toggleSortString}
            />
            <SortingTableHead title="Result" attr="result" location={['personalRecords', 'result']} sortFunction={toggleSortString} />
          </tr>
        </thead>
        <tbody>
          {table?.length > 0 ? (
            table?.map((item, index) => {
              return (
                <tr key={index}>
                  <SelectPlayerColumn player={item?.player} />
                  <td>{(item?.personalRecords?.date !== undefined || item?.personalRecords?.date !== null) ? item?.personalRecords?.date : '-'}</td>
                  <td>{(item?.personalRecords?.category !== undefined || item?.personalRecords?.category !== null) ? item?.personalRecords?.category : '-'}</td>
                  <td>{(item?.personalRecords?.situation !== undefined || item?.personalRecords?.situation !== null) ? item?.personalRecords?.situation : '-'}</td>
                  <td>{(item?.personalRecords?.result !== undefined || item?.personalRecords?.result !== null) ? item?.personalRecords?.result : '-'}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={5}>No Data</td>
            </tr>
          )}
        </tbody>
      </ScorecardTable>
    </TableContainer>
  );
};
